import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=7de1d580&scoped=true&"
import script from "./LoginFooter.vue?vue&type=script&lang=js&"
export * from "./LoginFooter.vue?vue&type=script&lang=js&"
import style0 from "./LoginFooter.vue?vue&type=style&index=0&id=7de1d580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de1d580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFooter,VRow})
